import React from "react";
import PropTypes from "prop-types";
import Form, { Input } from "../Components/SmartForm";

const SearchBar = ({
    id,
    action,
    placeholder = ""
}) => (
    <Form
        id={id}
        action={action}
        className="form-inline flex"
        method="GET"
        defaults={{
            sw: ""
        }}
    >
        <Input
            className="form-control flex-grow-1"
            type="text"
            name="sw"
            placeholder={placeholder}
            minLength={1}
        />
        <button
            type="submit"
            className="btn btn-sm btn-lx-search"
        >
            <i className="fa fa-search"></i>
        </button>
    </Form>
);

export default SearchBar;

SearchBar.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    placeholder: PropTypes.string
};